if (typeof Object.hasOwn !== 'function') {
  Object.defineProperty(Object, 'hasOwn', {
    value: function (obj: any, prop: any) {
      return Object.prototype.hasOwnProperty.call(Object(obj), prop)
    },
    writable: true,
    configurable: true,
  })
}
